
export const ResizableX = ({ children }) => (
  <div id="app">
    <div className="resizable-x">{children}</div>
  </div>
);

export const ResizableY = ({ children }) => (
  <div className="resizable-y">
    <div className="div1">{children}</div>
  </div>
);
